<template>
	<aside class="app-sidebar" :class="{ open: sidebarOpen }">
        <router-link to="/franchise/"  @click="closeSidebar">
            <img src="@/assets/logo.svg" alt="CIL Logo" class="logo" />
        </router-link>
        <div class="content">
            <div class="main-category">
                <ul class="sidebar-menu">
                    <li>
                        <router-link to="/franchise/"  @click="closeSidebar">
                            <i class="bi bi-house-fill"></i>Mes CIL
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="sub-category" style="flex: none;">
                <ul class="sidebar-menu one">
                    <li>
                        <router-link to="/franchise/ajouter"  @click="closeSidebar">
                            <i class="bi bi-tools"></i>Créer un CIL
                        </router-link>
                    </li>
                </ul>
            </div>
            <hr>
            <div class="main-category">
                <ul class="sidebar-menu">
                    <li>
                        <router-link to="/franchise/mon-agence"  @click="closeSidebar">
                            <i class="bi bi-wrench-adjustable"></i>Mon agence
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="sub-category">
                <ul class="sidebar-menu one">
                    <li>
                        <router-link to="/franchise/ajouter-compte">

                        </router-link>
                    </li>
                </ul>
                <ul class="sidebar-menu two" style="display:none">
                    <li>
                        <router-link to="/aides">
                            <i class="bi bi-question-circle"></i>Aides
                        </router-link>
                    </li>
                    <li style="margin-bottom: 0">
                        <router-link to="/parametres">
                            <i class="bi bi-gear-fill"></i>Paramètres
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </aside>
    <button class="hamburger" @click="toggleSidebar">
		<i class="bi bi-list"></i>
	</button>
	<div class="overlay" v-if="sidebarOpen" @click="closeSidebar"></div>
</template>

<script>
export default {
    name: "SideBar",
    data() {
		return {
			sidebarOpen: false,
		};
	},
    methods: {
        toggleSidebar() {
			this.sidebarOpen = !this.sidebarOpen;
		},
		closeSidebar() {
			this.sidebarOpen = false;
		},
        setActiveClass() {
            const currentRoute = this.$route.path;
            this.$nextTick(() => {
                const sidebarLinks = document.querySelectorAll(".sidebar-menu li");
                const sidebarContent = document.querySelector(".content hr");
                const mainCategory = document.querySelector(".main-category");
                const topCategory = document.querySelector(".sidebar-menu.one");
                const subCategory = document.querySelector(".sub-category");

                sidebarLinks.forEach(link => {
                    const href = link.querySelector("a").getAttribute("href");
                    if (currentRoute === href || currentRoute + "/" === href) {
                        link.classList.add("active");
                    } else {
                        link.classList.remove("active");
                    }
                });

                if (currentRoute === "/mes-logements") {
                    // sidebarContent.style.display = "none";
                    // mainCategory.style.display = "none";
                    // topCategory.style.display = "none";
                    // subCategory.style.justifyContent = "flex-end";
                } else {
                    sidebarContent.style.display = "";
                    mainCategory.style.display = "";
                    topCategory.style.display = "";
                    subCategory.style.justifyContent = "";
                }
            });
        }
    },
    watch: {
        $route() {
            this.setActiveClass();
        }
    },
    mounted() {
        this.setActiveClass();
    }
};
</script>

<style scoped>
.app-sidebar {
	width: 300px;
	min-width: 300px;
	padding: 50px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	background-color: #fff;
	position: sticky;
	top: 0;
	height: 100dvh;
	transition: transform 0.3s ease;
}

.app-sidebar.open {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	z-index: 1000;
	box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);
}

.app-sidebar .content {
	display: flex;
	flex: 1;
	flex-direction: column;
}

.hamburger {
	display: none;
	position: absolute;
	top: 20px;
	left: 10px;
	background: none;
	border: none;
	font-size: 24px;
	z-index: 1001;
	cursor: pointer;
}

.overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	z-index: 999;
}

@media (max-width: 950px) {
	.app-sidebar {
		display: none;
	}

	.app-sidebar.open {
		display: flex;
	}

	.hamburger {
		display: block;
	}
}

hr {
	width: 100%;
	margin: 10px 0 20px;
}

.logo {
	margin-bottom: 50px;
}

.sidebar-menu {
	list-style-type: none;
	padding: 0;
	margin: 0;
}

.sidebar-menu li {
	margin-bottom: 20px;
	position: relative;
}

.sidebar-menu li.active a {
	color: #359390;
}

.sidebar-menu li.active::before {
	content: "";
	position: absolute;
	top: 0;
	right: -50px;
	height: 100%;
	width: 3px;
	background-color: #359390;
}

.sidebar-menu li a {
	text-decoration: none;
	color: #000;
	display: flex;
	align-items: center;
	gap: 15px;
	transition: color 0.3s ease;
}

.sidebar-menu li a:hover {
	color: #359390;
}

.main-category a {
	font-size: 22px;
	font-weight: bold;
}

.sub-category {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.sub-category a {
	font-size: 20px;
}
</style>
